export default [
  //  IB的Client列表
  {
    name: "GetIbClientList",
    url: "/client/user/list",
    method: "GET",
    mock: false,
  },
  //  IB的Client详情
  {
    name: "GetIbClientDetail",
    url: "/client/user/get",
    method: "GET",
    mock: false,
  },
  // 获取软件下载工具列表
  {
    name: "IbListTool",
    url: "/tool/list",
    method: "GET",
    mock: false,
  },
  // 查询客户交易账户列表
  {
    name: "GetIbTradingAccountList",
    url: "/trading-account/list",
    method: "GET",
    mock: false,
  },
  // 查询返佣账号列表
  {
    name: "GetIbRebateAccountList",
    url: "/rebate-account/list",
    method: "GET",
    mock: false,
  },
  // 更改返佣账户权限
  {
    name: "UpdateIbRebateAccountPermission",
    url: "/rebate-account/update-permission",
    method: "POST",
    mock: false,
  },
  // IB个人信息详情
  {
    name: "GetIbDetail",
    url: "/user/get",
    method: "GET",
    mock: false,
  },
  // IB端-面板数据
  {
    name: "GetIbDashboardIbData",
    url: "/dashboard",
    method: "GET",
    mock: false,
  },
  // IB端-获取dashboard上次更新时间
  {
    name: "GetIbLastUpdateTime",
    url: "/dashboard/get-last-update-time",
    method: "GET",
    mock: false,
  },
  // 获取消息详情
  {
    name: "GetIBMessageDetail",
    url: "/message/get",
    method: "GET",
    mock: false,
  },
  // 获取消息列表
  {
    name: "GetIBMessageList",
    url: "/message/list",
    method: "GET",
    mock: false,
  },
  // 标记消息已读
  {
    name: "MarkIBMessageRead",
    url: "/message/mark-read",
    method: "POST",
    mock: false,
  },
  // 隐藏消息
  {
    name: "HideIBMessage",
    url: "/message/hide",
    method: "POST",
    mock: false,
  },
  // 获取未读消息数量
  {
    name: "GetIBMessageUnreadCount",
    url: "/message/unread-count",
    method: "GET",
    mock: false,
  },
];
